<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  (valueChange)="valueChange()"
  [erroremessage]="erroremessage"
  [noSubmit]="deactivateSave"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="content" *ngIf="formGroup">
    <ssg-input
      *ngIf="this.model && this.model.Id !== undefined && this.model.Id !== 0"
      name="ItemTitle"
      [group]="formGroup"
      [required]="true"
      required="false"
      [label]="'ClientApp.FrontOffice.Catalog.Additive.Items' | translate"
      required="false"
      textType="text"
      disabled="true"
      class="info">
    </ssg-input>
    <ssg-select
      *ngIf="!this.model || !this.model.Id || this.model.Id === 0"
      name="ItemId"
      [group]="formGroup"
      [required]="true"
      required="false"
      [label]="'ClientApp.FrontOffice.Catalog.Additive.Items' | translate"
      [dataList]="ItemIds"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()"
      userClass="select-md">
    </ssg-select>
    <ssg-select
      name="Categories"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Catalog.Additive.Categories' | translate"
      apiName="ItemCategory/ReadLookUp"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()"
      userClass="select-md">
    </ssg-select>
    <ssg-select
      name="Items"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Catalog.Additive.AuthorizedGoods' | translate"
      [dataList]="ItemWithCategory"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()"
      userClass="select-md">
    </ssg-select>
    <ssg-select
      name="IgnoredItems"
      [multiple]="true"
      [group]="formGroup"
      [label]="'ClientApp.FrontOffice.Catalog.Additive.IgnoredItems' | translate"
      [dataList]="IgnoredItemsWithCategory"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="valueChange()"
      userClass="select-md">
    </ssg-select>
  </div>
</dynamic-form>
